import React from 'react';
import { useStateValue } from "../StateProvider";
import "./FeedbackBody.css";

function NoMoreSongsToRate() {
  const [, dispatch] = useStateValue();

  const handleLogout = () => {
    // Clear the Spotify token to log the user out
    dispatch({
      type: "SET_TOKEN",
      token: null,
    });

    // Clear user info
    dispatch({
      type: "SET_USER",
      user: null,
    });

    // Clear user startseite
    dispatch({
      type: "SET_USERSTARTSEITE",
      userstartseite: {"id" : "nochnicht"},
    });

    // Clear session storage
    sessionStorage.clear();

    // Optionally clear local storage if you want to reset everything
    // localStorage.clear();

    // Redirect to login page by setting menustate
    dispatch({
      type: "SET_MENUSTATE",
      menustate: "feedbackcarouselmenu",
    });

    // Reload the page to ensure clean state
    window.location.href = '/';
  };

  return (
    <div className="feedbackBody" style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      padding: '40px 20px',
      textAlign: 'center'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '20px',
        padding: '40px',
        maxWidth: '600px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
      }}>
        <h1 style={{
          fontSize: '36px',
          marginBottom: '20px',
          color: '#1db954'
        }}>
          No More Songs to Rate
        </h1>

        <p style={{
          fontSize: '18px',
          lineHeight: '1.6',
          color: '#666',
          marginBottom: '30px'
        }}>
          You've rated all available songs! 🎉
        </p>

        <p style={{
          fontSize: '16px',
          lineHeight: '1.6',
          color: '#888',
          marginBottom: '40px'
        }}>
          Please come back later when more songs are available for rating.
          We're constantly adding new music for you to discover!
        </p>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '15px',
          alignItems: 'center'
        }}>
          <button
            onClick={() => dispatch({ type: "SET_MENUSTATE", menustate: "addownsong" })}
            style={{
              padding: '12px 30px',
              backgroundColor: '#1db954',
              color: 'white',
              border: 'none',
              borderRadius: '25px',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: 'pointer',
              boxShadow: '0 2px 8px rgba(29, 185, 84, 0.3)',
              transition: 'all 0.2s ease',
              width: '250px',
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 4px 12px rgba(29, 185, 84, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 2px 8px rgba(29, 185, 84, 0.3)';
            }}
          >
            Add Your Own Song
          </button>

          <button
            onClick={handleLogout}
            style={{
              padding: '12px 30px',
              backgroundColor: '#fff',
              color: '#333',
              border: '2px solid #ddd',
              borderRadius: '25px',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              width: '250px',
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#f5f5f5';
              e.target.style.borderColor = '#999';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#fff';
              e.target.style.borderColor = '#ddd';
            }}
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}

export default NoMoreSongsToRate;